module.exports = __webpack_public_path__ + "static/VMU_logo-12cdc274b9565f22a36fbd438c60d8fd.png";